// store
import { atom } from 'recoil';

const createdObjectUserAtom = atom<{ id: number | string; name: string } | null>({
  key: 'createdObjectUserAtom',
  default: null
});

export { createdObjectUserAtom };
